import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream border-y border-earth/20" data-id="element-126" data-mp="1o2vfqkp72f4g">
      <div className="max-w-4xl mx-auto" data-id="element-127" data-mp="223y4x6bhk5jl">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-forest/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-sm" data-id="element-128" data-mp="222n2b9ts13u2">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-forest" data-id="element-129" data-mp="1j5c29n0bm6dk"></div>

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-forest/10 text-forest mb-8" data-id="element-130" data-mp="1ed25bn0sg61s">
            <ShieldCheck size={48} data-id="element-131" data-mp="qmexf1qvhgf8" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-slate-900" data-id="element-132" data-mp="lpodu4fv02p2">
            🛡️ Garantía total de 7 días
          </h2>

          <div className="space-y-6 text-lg text-slate-700 max-w-2xl mx-auto" data-id="element-133" data-mp="oz9liwev73jg">
            <p data-id="element-134" data-mp="txbcs4mg2960">
              Abrí los 5 tomos. Revisá los 4 bonos. Usalos en tu clase más
              difícil esta semana.
            </p>
            <p className="font-bold text-slate-900" data-id="element-135" data-mp="yrp51y5t806g">
              Si sentís que tus alumnos no respondieron mejor, o que el material
              no te ahorró horas de trabajo:
            </p>
            <p className="text-forest font-bold text-xl" data-id="element-136" data-mp="630bck732x4q">
              Te entregamos el 100% de tu dinero. Sin preguntas. Sin
              formularios. Sin complicaciones.
            </p>
            <p className="text-sm text-slate-500 mt-8" data-id="element-137" data-mp="f3gc3lwfzq5w">
              Porque si el material no te da el valor que prometemos, no
              queremos quedarnos con tu dinero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}